import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)


export default {
  namespaced: true,
  state: {
    cambios: false,
    listaModulos: [],
    listaCategorias: [],
    listaPerfil: [],
    listaCatxPerfil: [],
    listaPerfilxUsuario: [],
    listaUsuarios: []

  },
  getters: {
    Cambios(state) {
      return state.cambios
    },

    ListaModulos(state) {
      return state.listaModulos
    },

    ListaCategorias(state) {
      return state.listaCategorias
    },

    ListaPerfil(state) {
      return state.listaPerfil
    },

    ListaCatxPerfil(state) {
      return state.listaCatxPerfil
    },

    ListaPerfilxUsuario(state) {
      return state.listaPerfilxUsuario
    },

    ListaUsuarios(state) {
      return state.listaUsuarios
    }


  },
  mutations: {
    llenarCambios(state, data) {
      state.cambios = data
    },

    llenarModulos(state, data) {
      state.listaModulos = data
    },

    llenarCategorias(state, data) {
      state.listaCategorias = data
    },

    llenarPerfil(state, data) {
      state.listaPerfil = data
    },

    llenarCatxPerfil(state, data) {
      state.listaCatxPerfil = data
    },

    llenarPerfilxUsuario(state, data) {
      state.listaPerfilxUsuario = data
    },

    llenarUsuarios(state, data) {
      state.listaUsuarios = data
    }




  },


  actions: {
    CambiosEstado({ commit }, cambio) {
      commit("llenarCambios", cambio)
    },

    ListarPerfil({ commit }) {
      axios.get(`BIClientes/ListarPerfil`).then((r) => {
        commit('llenarPerfil', r.data)
        console.log(r.data)
      });
    },

    ListarModulo({ commit }) {
      axios.get(`BIClientes/ListarModulos`).then((r) => {
        commit('llenarModulos', r.data)
      });
    },


    ListarCategorias({ commit }) {
      axios.get(`BIClientes/ListarCategoria`).then((r) => {
        commit('llenarCategorias', r.data)
        console.log('listado de', r.data)
      });
    },

    ListarCatxPerfil({ commit }) {
      axios.get(`BIClientes/ListarcatxPerfil`).then((r) => {
        commit("llenarCatxPerfil", r.data)
      });
    },

    ListarPerfilxUsuario({ commit }) {
      axios.get(`BIClientes/ListarAcceso`).then((r) => {
        commit('llenarPerfilxUsuario', r.data)
      });
    },

    ListarUsuarios({ commit }) {
      axios.get(`BIClientes/ListarUsuarios`).then((r) => {
        commit('llenarUsuarios', r.data)
      });
    }




  },
  modules: {
  }
}
